import { memo } from 'react';
import clsx from 'clsx';
import { ProductImage } from 'src/modules/common/components/ProductImage/ProductImage.tsx';

type Props = {
    title: string;
    checked: boolean;
    disabled: boolean;
    isSingleVariant: boolean;
    onChange: () => void;
    imageURL: string;
}

export const HomeValve = memo(({ title, disabled, isSingleVariant, checked, onChange, imageURL }: Props) => (
    <button
        type="button"
        className={clsx({
            'vss-home-valve': true,
            'vss-home-valve--disabled': disabled,
            'vss-home-valve--single-variant': isSingleVariant,
        })}
        onClick={disabled ? () => null : onChange}
    >
        <div className="vss-home-valve__header">
            <h2 className="vss-home-valve__title">
                {title}
            </h2>

            <div className={clsx({
                'vss-home-valve__checkbox': true,
                'vss-home-valve__checkbox--checked': checked,
                'vss-home-valve__checkbox--disabled': disabled,
            })}
            />
        </div>

        <div className="vss-home-valve__image">
            <ProductImage imgSrc={imageURL} imgAlt={title}/>
        </div>
    </button>
));
